export const OrderTabs = {
  Address: "address",
};

export const OrderTranslationNamespaceEnum = {
  CreateOrder: "OrderCreate",
};

export const OrderQueryKeys = {
  orderBasketData: "order.basket-data",
  orderCustomerSearch: "order.customer.search",
};

export const customerModalFormKey = "order-customer-modal-form";
export const orderDeliveryAddressFormKey = "order-delivery-address-modal-form";

export const OrderStatusEnum = {
  New: "New",
  Cancelled: "Cancelled",
  Finished: "Finished",
  Problems: "Problems",
};
